module.exports = __webpack_public_path__ + "img/completion_right_2.3a0b1328.jpg";